import React from 'react';
import { HiOutlinePlus, HiOutlineCursorArrowRays, HiOutlineXMark, HiOutlineTrash } from 'react-icons/hi2';
import { Search } from 'react-bootstrap-icons';
import './FilterBar.scss';

interface FilterBarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  showSelection: boolean;
  selectedCount: number;
  onToggleSelection: () => void;
  onCreatePuesto: () => void;
  onDeleteSelection?: () => void;
  canCreate: boolean;
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchValue,
  onSearchChange,
  showSelection,
  selectedCount,
  onToggleSelection,
  onCreatePuesto,
  onDeleteSelection,
  canCreate,
}) => {
  return (
    <div className="mp-toolbar flex flex-wrap items-center gap-3">
      <div className="search-wrapper">
        <Search size={14} className="search-icon" />
        <input
          type="text"
          placeholder="Buscar puestos..."
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {!showSelection && canCreate && (
          <button className="mp-btn-primary" onClick={onCreatePuesto}>
            <HiOutlinePlus size={16} />
            Crear puesto
          </button>
        )}

        {canCreate && (
          <button className="mp-toolbar-btn" onClick={onToggleSelection}>
            {showSelection ? (
              <>
                <HiOutlineXMark size={16} />
                Cancelar selección
              </>
            ) : (
              <>
                <HiOutlineCursorArrowRays size={16} />
                Seleccionar
              </>
            )}
          </button>
        )}

        {showSelection && selectedCount > 0 && onDeleteSelection && (
          <button className="mp-btn-danger" onClick={onDeleteSelection}>
            <HiOutlineTrash size={16} />
            Eliminar selección ({selectedCount})
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
